import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/layouts/post-layout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`I got in copilot preview today and I tried it with a Leetcode question. Dispite it cannot solve the problem,
it provides great hint on the solution. This would be a great help if can be used during development!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      